export const Alias = {
    FARM : 'selectFarm',
    FARM_SETTINGS: 'settingsFarm',
    FARM_LICENSES: 'licensesFarm',
    CROSS_FARM_DASHBOARD: 'crossFarmDashboard',
    USER_SETTINGS: 'settingsUser',
    DRAW: 'drawField',
    FIELD_UPLOAD: 'uploadField',
    FIELD_UPLOAD_SUCCESS: 'uploadFieldSuccess',
    BOUNDARY_DETECTION: 'boundaryDetection',
    BOUNDARY_DETECTION_SUCCESS: 'boundaryDetectionSuccess',
    EDIT_FIELD: 'editField',            // edit the field
    HOME: 'home',
    LOGIN: 'login',
    REGISTRATION: 'registration',
    REGISTRATION_2019: 'registration-2019',
    REGISTRATION_HEALTHY_FIELDS: 'registration-hf',
    REGISTRATION_HEALTHY_FIELDS_CONTRACTOR: 'registration-hf-contractor',
    REGISTRATION_HF_CONTRACTOR: 'hf-contractor',
    CREATE: 'createField',
    STATUS: 'showFarmStatus',
    WEATHER: 'showFarmWeather',
    FORWARD: 'FORWARD',
    DRAW_SUCCESS: 'createFieldSuccess',
    ASSIGN_CS: 'assignCropSeason',
    EDIT_CS: 'editCropSeason',          //edit the crop
    TIMING: 'timing',
    RESET_PASS: 'resetPassword',
    FORGOT_PASS: 'forgotPassword',
    REGISTRATIONS_CLOSED: 'registrationsClosed',
    PAGE_NOT_FOUND: 'error404',
    NOT_AUTHORIZED: 'error403',
    TASK_OBSERVATION_CREATE: 'createObservationTask',
    TASK_SPRAYING_CREATE: 'createSprayingTask',
    TASK_HERBICIDE_CREATE: 'createHerbicideTask',
    TASK_NUTRITION_CREATE: 'createNutritionTask',
    TASK_DRONE_FLIGHT_CREATE: 'createDroneFlightTask',
    TASK_SPRAYING_EDIT: 'editSprayingTask',
    TASK_HERBICIDE_EDIT: 'editHerbicideTask',
    TASK_NUTRITION_EDIT: 'editNutritionTask',
    TASK_SCOUTING_CREATE: 'createScoutingTask',
    TASK_SCOUTING_EDIT: 'editScoutingTask',
    TASKS: 'taskList',
    FIELDS: 'fields',
    SHOP_PRODUCTS: 'products',
    UNDER_CONSTRUCTION: 'underConstruction',
    TC_ACCEPTED: 'tcAccepted',
    EMAIL_VERIFIED: 'emailVerified',
    RESET_CACHE: 'resetCache',
    FIELD_DATA_LAYERS: 'fieldDataLayers',
    SHOP_ORDER: 'showOrder',
    INVITE_COLLABORATORS: 'inviteCollaborators',
    FDL_UPLOADS: 'fdlUploads',
    HEALTHY_FIELDS_DASHBOARD: 'healthyFieldsDashboard',
    HEALTHY_FIELDS_OVERVIEW: 'healthyFieldsOverview',
    HEALTHY_FIELDS_SERVICES: 'healthyFieldServices',
    HEALTHY_FIELDS_REQUEST: 'healthyFieldsRequest',
    HEALTHY_FIELDS_CONTRACTOR_REQUEST: 'healthyFieldsContractorRequest',
    DOWNLOAD_HISTORY: 'downloadHistory',
    CONNECTED_APPS: 'connectedApps',
    SHOP_PAYMENT_SUCCESS: 'shopPaymentSuccess',
    SHOP_PAYMENT_FAILED: 'shopPaymentFailed',
    FORWARD_LAYOUT: 'forwardLayout',
    WEATHER_STATIONS: 'weatherStations',
    MANAGEMENT_ZONES: 'managementZones',
    DRAW_MANAGEMENT_ZONES: 'drawManagementZones',
    EDIT_MANAGEMENT_ZONES: 'editManagementZones',
    AB_LINES: 'abLines',
    DRAW_AB_LINES: 'drawABLines',
    EDIT_AB_LINES: 'editABLines',
    DRAW_TRAMLINES: 'drawTramlines',
    EDIT_TRAMLINES: 'editTramlines',
    FIELD_ENTRIES: 'fieldEntries',
    ADD_FIELD_ENTRIES: 'addFieldEntries',
    EDIT_FIELD_ENTRIES: 'editFieldEntries',
    SCOUTING: 'scouting',
    DATA_ATTRIBUTION: 'dataAttribution',
    NOTES: 'notes',
    SUSTAINABILITY: 'sustainability',
    V2_APP: 'v2App'
};


// WEBPACK FOOTER //
// ./js/alias.js